// eslint-disable-next-line import/prefer-default-export
export const NEW_SHELVES_ERROR_MESSAGES = {
  NAME_IS_REQUIRED: 'Введите название полки',
};
